<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from './list/setup'
import Transaction from './list/transaction'
import UpdateApplicationModal from './modals/update_application'
import PaymentHistoryModal from './modals/payment_history'
import { notify } from '@/helpers/notify' 
import Ability from '@/helpers/mixins/ability'
import CreatePaymentModal from './modals/create_payment'
import TechDetay from './modals/tech_detail'
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {  
    page: { title: "Kurulum Bekleyenler" },
    components: {
      Layout,
      PageHeader,
      CreateSetup,
      Transaction,
      UpdateApplicationModal,
      PaymentHistoryModal,
      CreatePaymentModal,
      TechDetay,
      Datatable
    }, 
    mixins: [ Ability, datatableMixin ],
    data() {
     return {
        title: "KURULUM BEKLEYENLER",
        items: [
            { text: "ANASAYFA", href: "/" },
            { text: "KURULUM BEKLEYENLER", active: true }
        ],
        searchParams: {},
        columns: [
            { name: '', key: 'action', orderable: false },
            { name: 'Kullanıcı Adı', key: 'username'},
            { name: 'İsim Soyisim', key: 'fullname', width: 150 },
            { name: 'Kayıt Tarihi', key: 'created_at', className: 'text-end',orderable: true, width: 150  },
            { name: 'Randevu Tarihi', key: 'appointment', className: 'text-end', orderable: true, width: 150  },
            { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
            { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
            { name: 'İl', key: 'province', className: 'text-end', width: 150  },
            { name: 'Bölge', key: 'township', className: 'text-end',  width: 150  },
            { name: 'Adres', key: 'address', className: 'text-end',  width: 150  },
            { name: 'Personel', key: 'user_name', className: 'text-end',  width: 150  },
            { name: 'Bayisi', key: 'belong_name', className: 'text-end',  width: 150  },
            { name: 'Servis', key: 'tariff_name', className: 'text-end',  width: 350  },
        ],
        tableData: {
        detail: false,
        excel: true,
          searchable:{
            visible:true,
            placeholder:"İsim Soyisim Ara"
          }
        },
        endpoint: '/listeler/kurulum-bekleyenler',
        exportName: 'KURULUM_BEKLEYENLER',
        buttons:[
          { title:"Düzenle", icon:'bx bx-edit', func:this.edit, name:'duzenle', key:'duzenle', abilities:'admin|dealer'},
          { title:"Sil", icon:'bx bx-trash', func:this.silModel, name:'sil', key:'sil', abilities:'admin|personel'},
        ],  
        transactionData: {},
        data: {},
        detailSearch: false,
        kurulumRandevusu: true,
        trIndex: 0,
        currentRow: {},
        explaine: '',
        searchBox: {},
        updateSubsId: null,
        paymentHistoryData: {},
        modelOpen: 0,
        tekrarRandevuOpen: 0,
        showSubMenu: false,
        deleteSubsId:0,
        basvuruCount:0,
        techDetailData: {}
      };
    },
    computed: {
      ...mapGetters('authfack',['userdata'])
      
    },
    mounted(){
      if(this.userdata.currentUser.role_name == 'admin' || this.userdata.currentUser.role_name == 'personel'){
        this.buttons.unshift({ title:"Randevu Ver", icon:'bx bx-calendar-event', func:this.randevuVer , key:'randevu'})
      }
      if(this.userdata.currentUser.role_name == 'admin'){
        this.buttons.unshift({ title:"İşleme Al", icon:'check', func:this.islemeAl , key:'islemeal'})
      }
	},
    methods: {
      popoverContent(histories) {
        const listItems = histories.map(history => {
          return `
            <li>${(history.description || '').replace(/\n/g, '<br>')}</li>
          `;
        }).join('');

        return `<ul>${listItems}</ul>`;
      },

      iptalNote(row) {
        return row.iptal_notu || row.postpone_note || '';
      },

      showTechDetail(row) {
        this.techDetailData = {
          ...row,
          type: 1,
          iptal_notu: this.iptalNote(row),
        };
        this.$parent.$bvModal.show('tech_detail');
      },
      
      async loadPage() {
          
          this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
          
          const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
          if (this.params.page === 1) {
              this.tableData.data = response.data.data;
          } else {
              this.tableData.data = [...this.tableData.data, ...response.data.data];
          }
      
          this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
          this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
      },
          
      
      islemeAl(obj){

        this.$swal({
            title: "İşleme Al",
            text: "İşleme almak istiyormusunuz?",
            showCancelButton: true,
            cancelButtonText: "İptal",
            confirmButtonText: "Evet, İşleme Al!"
        }).then((result) => {
            if (result.value) {
              this.loading = true
              
              this.$http.post('/members/isleme-al', {  subs_id:obj.subs_id, type_id: 1 })
              .then(response => {
                  if(response.data.code == 100){
                    this.loading = false
                    return notify.success(response.data.message)
                  }
                  this.loading = false
                  return notify.error(response.data.message)
              })
            }
        });
      },

      appointment(obj){
          if(obj.appointment_at){
              if(obj.postpone){
                const isCancel = Number(obj.postpone) === 2;
                const badge = isCancel
                  ? "<span class='badge rounded-pill bg-danger font-size-12'>İptal Talep</span> "
                  : "<span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span> ";
                const desc = (obj.hasOwnProperty('histories') && obj.histories.length > 0 ? obj.histories[0].description : '');
                return badge + desc;
              }
              return this.formatDate(obj.appointment_at, 'DD.MM.YYYY HH')   
          }
          return  '-'
      },

      created_at(obj){
        return this.formatDate(obj.created_at, "DD.MM.YYYY HH:mm")
      },

     
      ok(obj){
        return obj.approval == null ? "<button class='btn btn-outline-info btn-sm'>Onay</button>" : obj.approval
      },

      installed(obj){
        return obj.installed || '<i class="text-danger fa fa-minus"></i>'
      },

      createSetup(prop){
        this.data = { type:1, subs_id :prop.subs_id }
        this.$parent.$bvModal.show('setup')
      },

      randevuVer(props){
        this.modelOpen += 1
        this.createSetup(props)
      },

      edit(props){
        this.updateSubsId = props.subs_id
        this.basvuruCount += 1
        this.$parent.$bvModal.show('update_application_modal')
      },

      paymentHistory({username, subs_id}){
        this.paymentHistoryData = { id:subs_id, username}
        this.$parent.$bvModal.show('payment_history_modal')
      },

      createPayment(props){
        this.$store.dispatch('userDetail/setUserDetail', { id:props.subs_id, component:'onodeme', paymnet_type:'' });
        this.$bvModal.show('create_payment_modal')
      },

      onayla(){
        this.$http.get('/members/'+ this.currentRow.id + '/onayla')
                    .then(resp => {
                        this.kurulumRandevusu = true
                        this.rows[this.trIndex]["approval"] = resp.data
                      })
      },

      silModel({ subs_id }){
        this.deleteSubsId = subs_id
        this.$parent.$bvModal.show('delete-scoped')
      },

      close(){
        this.$parent.$bvModal.hide('delete-scoped')
      },

      sil(){
        this.isLoading = true
        this.$http.delete('/members/'+ this.deleteSubsId  + '?explaine=' + this.explaine)
        .then(() => {
          notify.success('Başarılı')
          this.close()
          this.loadPage()
        })
      },
      
      tekrarRandevuVer(prop){
        this.tekrarRandevuOpen += 1

        this.data = {
          type: 1,
          id: prop.id,
          postpone: prop.postpone,
          iptal_notu: this.iptalNote(prop),
        }
        this.$parent.$bvModal.show('setup')
      },

      isRandevuVisible({ appointment_at }){
        const adminRole = this.userdata.currentUser.role_name == 'admin' || this.userdata.currentUser.role_name == 'personel'
        if(appointment_at && adminRole){
          return true;
        }
        return false;
      },

      appointmentVisible(name, prop){
        if(name == 'randevu' && prop.appointment_at){ // verildiyse randevu daha önce butonu sil
          return false
        }
     
        return true
      },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

    <CreateSetup  
      :data="modelOpen"
      :update="tekrarRandevuOpen"
      :type="data.type" 
      :subs_id="data.subs_id"
      :id="data.id"
      :postpone="data.postpone"
      :iptal_notu="data.iptal_notu"
      :randevu="true" 
      @loadItems="loadPage"
    />

    <TechDetay :data="techDetailData" />

    <Transaction 
      :transactionData="transactionData" 
      @loadItems="loadPage"  
    />

    <UpdateApplicationModal 
      :data="updateSubsId" 
      :openModal="basvuruCount"
    />

    <PaymentHistoryModal 
      :data="paymentHistoryData" 
    />

    <CreatePaymentModal />
    
    <b-modal id="delete-scoped" title="Kurulum Sil"  no-close-on-backdrop hide-footer>
        <form>
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label>Neden İptal Edildi</label>
                        <textarea class="form-control" v-model="explaine"></textarea>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <b-button variant="light" @click="close()">Vazgeç</b-button>
              <b-button 
                  type="button"
                  @click="sil" 
                  variant="success" 
                  class="ms-1"
                  >Onayla
              </b-button>
            </div>
        </form>
    </b-modal>

    <div class="row"> 
      <div class="col-12">
        <Datatable 
          :columns="columns" 
          :tableData="tableData" 
          @sort-column="handleSortColumn"
          @search-query="reLoadPage"
          @excel-export="excelExport"
          :loading="isLoading"
          :poading="pageLoading">
          
          <template #created_at="{ row }">
              {{ created_at(row) }}
          </template>
          <template #appointment="{ row }">
            <div v-if="row.postpone">
              <span
                role="button"
                class="badge rounded-pill font-size-12 mb-1"
                :class="Number(row.postpone) === 2 ? 'bg-danger' : 'bg-warning'"
                style="cursor: pointer;"
                @click="showTechDetail(row)"
              >
                {{ Number(row.postpone) === 2 ? 'İptal Talep' : 'Ertelenmiş' }}
              </span>
              <div
                v-if="iptalNote(row)"
                class="small text-muted mt-1"
                style="white-space: pre-line; max-width: 280px; cursor: pointer;"
                @click="showTechDetail(row)"
              >{{ iptalNote(row) }}</div>
            </div>
            <div v-else>
              {{ formatDate(row.appointment_at, 'DD.MM.YYYY HH') }}
            </div>
          </template>

          <template #address="{ row }">
            <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
          </template>

          <template #expiredate="{ row }">
              {{ expiredate(row.expiredate) }}
          </template>
          <template #phonenumber="{ row }">
              <a :href="`tel:${row.phonenumber}`"  >{{row.phonenumber}}</a>
          </template>
          <template #phonenumber2="{ row }">
                <a target="_blank" :href='`https://wa.me/${row.phonenumber2}`' >{{ row.phonenumber2}}</a>
          </template>
          
          <template #action="{ row }">
              <b-dropdown
                  toggle-class="font-size-16 p-0"
                  toggle-tag="a"
                  variant="white"
                  append-to-body
                  >
                  <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template> 
                    <b-dropdown-item 
                      v-if="ability('admin|personel')"
                      @click="createPayment(row)">
                      Ödeme Al
                    </b-dropdown-item>
                      <b-dropdown-item 
                      v-if="ability('dealer')"
                      @click="createPayment(row)">
                      Taksit Ödemesi Al 
                    </b-dropdown-item>
                    <b-dropdown-item 
                    v-if="ability('admin|personel')"
                      @click="paymentHistory(row)">
                      Ödeme Geçmişi
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="Number(row.postpone) === 2"
                      @click="showTechDetail(row)">
                      İptal Talebi Detay
                    </b-dropdown-item>
                    <b-dropdown-item 
                      v-if="isRandevuVisible(row)"
                      @click="tekrarRandevuVer(row)">
                       Tekrar Randevu Ver
                    </b-dropdown-item>
                    <template   
                    v-for="(button,i) in buttons" >
                    <b-dropdown-item 
                      :key="i" 
                      v-if="appointmentVisible(button.key, row) && ability(button.abilities)"
                      @click="button.func(row)">
                      {{ button.title }}
                    </b-dropdown-item>
                  </template>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
